import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const FAKE_FARMS = [
  { id: "farm-001", name: "Finca Las Palmas" },
  { id: "farm-002", name: "Finca El Roble" },
  { id: "farm-003", name: "Finca La Esperanza" },
  { id: "farm-004", name: "Finca San José" },
  { id: "farm-005", name: "Finca Santa Rita" },
];

const FAKE_WAREHOUSES_BY_FARM = {
  "farm-001": [
    { id: "wh-001", name: "Almacén Central" },
    { id: "wh-002", name: "Almacén Norte" },
    { id: "wh-003", name: "Almacén Sur" },
    { id: "wh-004", name: "Almacén Este" },
    { id: "wh-005", name: "Almacén Oeste" },
  ],
  "farm-002": [
    { id: "wh-010", name: "Almacén Principal" },
    { id: "wh-011", name: "Almacén Secundario" },
    { id: "wh-012", name: "Almacén Externo" },
    { id: "wh-013", name: "Almacén Temporal" },
    { id: "wh-014", name: "Almacén Eventos" },
  ],
};

const FAKE_COLLABORATORS = [
  { id: "col-0001", name: "Juan Pérez" },
  { id: "col-0002", name: "María Gómez" },
  { id: "col-0003", name: "Carlos Rojas" },
  { id: "col-0004", name: "Ana Martínez" },
  { id: "col-0005", name: "Luis Díaz" },
];

const WarehouseMaintenanceForm = ({
  onSubmit,
  type = "create",
  initialValues = {},
  onCancel,
}) => {
  const defaultState = {
    date: "",
    farmId: "",
    farmName: "",
    warehouseId: "",
    warehouseName: "",
    protocolDescription: "",
    performedById: "",
    performedByName: "",
    photoEvidence: "",
    observations: "",
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });
  const [availableWarehouses, setAvailableWarehouses] = useState([]);

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });

    if (initialValues.farmId) {
      const whs = FAKE_WAREHOUSES_BY_FARM[initialValues.farmId] || [];
      setAvailableWarehouses(whs);
      if (initialValues.warehouseId && !initialValues.warehouseName) {
        const foundWh = whs.find((w) => w.id === initialValues.warehouseId);
        if (foundWh) setForm((f) => ({ ...f, warehouseName: foundWh.name }));
      }
    }

    if (initialValues.performedById && !initialValues.performedByName) {
      const found = FAKE_COLLABORATORS.find(
        (c) => c.id === initialValues.performedById
      );
      if (found) setForm((f) => ({ ...f, performedByName: found.name }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleFarmChange = (farmId) => {
    const farm = FAKE_FARMS.find((f) => f.id === farmId);
    const whs = FAKE_WAREHOUSES_BY_FARM[farmId] || [];
    setAvailableWarehouses(whs);
    setForm({
      ...form,
      farmId,
      farmName: farm ? farm.name : "",
      warehouseId: "",
      warehouseName: "",
    });
  };

  const handleWarehouseChange = (warehouseId) => {
    const wh = (availableWarehouses || []).find((w) => w.id === warehouseId);
    setForm({ ...form, warehouseId, warehouseName: wh ? wh.name : "" });
  };

  const onSubmitForm = () => {
    const payload = { ...form };
    if (!payload.createdAt) payload.createdAt = new Date().toISOString();
    onSubmit && onSubmit(payload);
  };

  return (
    <Grid rowGap="12px" columnGap="12px" padding="20px">
      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="date"
          label={strings.fields.date.label}
          placeholder="YYYY-MM-DD"
          value={form.date || ""}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
        />
        <SelectField
          name="farmId"
          label={strings.fields.farmId.label}
          value={form.farmId || ""}
          onChange={(e) => handleFarmChange(e.target.value)}
        >
          <option value="">--</option>
          {FAKE_FARMS.map((f) => (
            <option key={f.id} value={f.id}>
              {f.name}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <SelectField
          name="warehouseId"
          label={strings.fields.warehouseId.label}
          value={form.warehouseId || ""}
          onChange={(e) => handleWarehouseChange(e.target.value)}
        >
          <option value="">--</option>
          {availableWarehouses.map((w) => (
            <option key={w.id} value={w.id}>
              {w.name}
            </option>
          ))}
        </SelectField>

        <SelectField
          name="performedById"
          label={strings.fields.performedById.label}
          value={form.performedById || ""}
          onChange={(e) => {
            const val = e.target.value;
            const found = FAKE_COLLABORATORS.find((c) => c.id === val);
            setForm({
              ...form,
              performedById: val,
              performedByName: found ? found.name : "",
            });
          }}
        >
          <option value="">--</option>
          {FAKE_COLLABORATORS.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </SelectField>
      </Grid>

      <TextAreaField
        name="protocolDescription"
        label={strings.fields.protocolDescription.label}
        value={form.protocolDescription || ""}
        onChange={(e) =>
          setForm({ ...form, protocolDescription: e.target.value })
        }
      />

      <TextAreaField
        name="observations"
        label={strings.fields.observations.label}
        value={form.observations || ""}
        onChange={(e) => setForm({ ...form, observations: e.target.value })}
      />

      <TextField
        name="photoEvidence"
        label={strings.fields.photoEvidence.label}
        placeholder="foto1.jpg, foto2.jpg"
        value={
          Array.isArray(form.photoEvidence)
            ? form.photoEvidence.join(", ")
            : form.photoEvidence || ""
        }
        onChange={(e) => setForm({ ...form, photoEvidence: e.target.value })}
      />

      <Flex justifyContent="end">
        <Button
          children={strings.fields.buttons.reset}
          onClick={() => setForm(defaultState)}
        />
        <Button
          children={
            type === "create"
              ? strings.fields.buttons.create
              : strings.fields.buttons.save
          }
          onClick={onSubmitForm}
          variation="primary"
        />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      date: { label: "Fecha" },
      farmId: { label: "Finca" },
      warehouseId: { label: "Almacén" },
      protocolDescription: { label: "Descripción del protocolo" },
      performedById: { label: "Persona que realiza" },
      photoEvidence: { label: "Evidencia fotográfica" },
      observations: { label: "Observaciones" },
      createdAt: { label: "Fecha de creación" },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
        cancel: "Cancelar",
      },
    },
  },
});

export default WarehouseMaintenanceForm;
